import { Controller } from '@hotwired/stimulus'
import captureEvent from '@/v2/posthog'

export default class extends Controller<HTMLElement> {
  private clickingSubmit = false

  connect (): void {
    this.element.addEventListener('mousedown', (e: MouseEvent) => {
      if ((e.target as HTMLElement).closest('[type="submit"]')) {
        this.clickingSubmit = true
      }
    }, true)

    this.element.addEventListener('blur', (e: FocusEvent) => {
      const input: HTMLInputElement = e.target as HTMLInputElement

      // A submit button blurs when its own submission makes the form inert;
      // autosaving then would abort that submission.
      if (input.name !== '' && input.type !== 'submit') {
        captureEvent('Intake Form', input.name)
        if (!this.clickingSubmit) {
          input.form?.requestSubmit()
        }
      }
      this.clickingSubmit = false
    }, true)
  }
}
